var _defs, _style, _path, _path2, _path3, _path4, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndiewebcamp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 145 64",
    width: 145,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "indiewebcamp-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-2.52-2.3h150.52v71.53h-150.52z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-2.52-2.3h150.52v71.53h-150.52z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-2.52-2.3h150.52v71.53h-150.52z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-2.52-2.3h150.52v71.53h-150.52z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-2.52-2.3h150.52v71.53h-150.52z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-2.52-2.3h150.52v71.53h-150.52z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-2.52-2.3h150.52v71.53h-150.52z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-2.52-2.3h150.52v71.53h-150.52z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-2.52-2.3h150.52v71.53h-150.52z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-2.52-2.3h150.52v71.53h-150.52z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-2.52-2.3h150.52v71.53h-150.52z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-2.52-2.3h150.52v71.53h-150.52z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-2.52-2.3h150.52v71.53h-150.52z"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #ff5c00 } \n\t\t.s1 { fill: #ff0000 } \n\t\t.s2 { fill: #ffb100 } \n\t\t.s3 { fill: #666666 } \n\t\t.s4 { fill: #444444 } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m48.1 7.9l18.3 39 5.7-12.3-12.4-26.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m100.4 7.9h-15.8-20.7l12 25.7 6.2 13.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m7.7 7.9h36.4v10.2h-36.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m7.7 21.8h36.4v22.2h-36.4z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m137.5 28c-0.9 10-9.4 17.8-19.6 17.8-10.9 0-19.7-8.8-19.7-19.7 0-10.9 8.8-19.7 19.7-19.7 10.2 0 18.6 7.8 19.6 17.7h-19.6c-1.1 0-1.9 0.9-1.9 1.9 0 1.1 0.8 2 1.9 2 0 0 19.6 0 19.6 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m7.8 51.6h1.3v7.4h-1.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m15.7 51.5l4.8 4.6v-4.5h1.3v7.5h-0.1l-4.7-4.6v4.5h-1.3v-7.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s3",
    d: "m27.4 59v-7.4h2.7c2.8 0 3.7 2.1 3.7 3.7 0 1.6-0.9 3.7-3.7 3.7zm2.6-1.1c2 0 2.3-2 2.3-2.6 0-0.7-0.3-2.6-2.3-2.6h-1.4v5.2c0 0 1.4 0 1.4 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m39.4 51.6h1.3v7.4h-1.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m48.3 55.9v2h3.7v1.1h-5v-7.4h5v1.1h-3.7v2.1h2.9v1.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m63 54.5l-2.1 4.6h-0.1l-3.4-7.5h1.4l2.1 4.7 2-4.9h0.1l2.1 4.9 2-4.7h1.5l-3.5 7.5h-0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m74.3 55.9v2h3.7v1.1h-5v-7.4h5v1.1h-3.7v2.1h2.9v1.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s4",
    d: "m88.7 55.3c0.6 0.2 0.9 1 0.9 1.6 0 0.9-0.6 2.1-2.7 2.1h-2.8v-7.4h2.8c2.1 0 2.7 1.2 2.7 2.1 0 0.6-0.3 1.3-0.9 1.6zm-1.6-0.5c1-0.1 1.1-0.8 1.1-1.1 0-0.2-0.1-1-1.2-1h-1.6v2.1c0 0 1.7 0 1.7 0zm-0.1 3.1c1.1 0 1.2-0.8 1.2-1 0-0.4-0.1-0.9-1.1-1h-1.7v2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m100.9 53.6c-0.4-0.5-1.2-1-1.9-1-2.1 0-2.4 2-2.4 2.7 0 0.6 0.3 2.6 2.4 2.6 0.7 0 1.5-0.4 2-0.9l0.8 0.9c-0.8 0.8-1.6 1.2-2.8 1.2-2.9 0-3.8-2.2-3.8-3.8 0-1.6 0.9-3.9 3.8-3.9 1.2 0 2.1 0.6 2.8 1.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s3",
    d: "m112.6 59h-1.5l-0.8-1.9h-2.4l-0.8 1.9h-1.5l3.5-7.5h0.1zm-4.3-3h1.6l-0.8-1.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m120.7 59.1l-2.2-4.4-1.4 4.3h-1.4l2.6-7.5h0.1l2.3 5.1 2.3-5.1h0.1l2.7 7.5h-1.4l-1.4-4.3-2.2 4.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s3",
    d: "m131.8 59h-1.3v-7.4h2.8c2 0 2.7 1.4 2.7 2.3 0 1.5-1.3 2.5-2.5 2.5h-1.7c0 0 0 2.6 0 2.6zm1.6-3.8c1-0.1 1.2-0.9 1.2-1.3 0-0.4-0.2-1.2-1.2-1.2h-1.6v2.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndiewebcamp);
export default __webpack_public_path__ + "static/media/indiewebcamp.56f35aff0f247b9c82baf32cc8dd11d1.svg";
export { ForwardRef as ReactComponent };